"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Logger_1 = require("../../util/Logger");
var EntityArgs = (function () {
    function EntityArgs(one, many, params) {
        this.one = one;
        this.many = many;
        this.params = params;
    }
    EntityArgs.isValid = function (args) {
        var errors = Object.keys(args).reduce(function (previous, field) {
            if (field === "params") {
                return previous;
            }
            if (EntityArgs.validFields.indexOf(field) < 0) {
                return previous += ("," + field);
            }
            if (typeof args[field] !== "string") {
                return previous += ("," + field);
            }
            return previous;
        }, "");
        Logger_1.default.warn(errors);
        return errors.length <= 0;
    };
    EntityArgs.parseArgs = function (arg1) {
        if (EntityArgs.isValid(arg1)) {
            return arg1;
        }
        Logger_1.default.throw("arguments.entity");
        return new EntityArgs();
    };
    EntityArgs.prototype.isValid = function () {
        return EntityArgs.isValid(this);
    };
    EntityArgs.validFields = ["one", "many", "create", "update", "delete"];
    return EntityArgs;
}());
exports.default = EntityArgs;
//# sourceMappingURL=EntityArgs.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/decorators/entity/EntityArgs.js
// module id = 1450
// module chunks = 0